import { render } from "./MessageBox.vue?vue&type=template&id=35810e66&scoped=true"
import script from "./MessageBox.vue?vue&type=script&lang=js"
export * from "./MessageBox.vue?vue&type=script&lang=js"

import "./MessageBox.vue?vue&type=style&index=0&id=35810e66&lang=less&scoped=true"

import exportComponent from "D:\\AIDA\\dlvip-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35810e66"]])

export default __exports__